import React, { useState, useEffect } from "react";

import TextField from "../../../Components/Commons/Forms/TextField";
import BtnSave from "../../../Components/Commons/Buttons/BtnSave";
import BtnAdd from "../../../Components/Commons/Buttons/BtnAdd";
import TextArea from "../../Commons/Forms/TextArea";
// import SketchPad from "../../../Components/Commons/Forms/SketchPad";
import CreateSelectField from "../../../Components/Commons/Forms/CreateSelectField";
import SelectField from "../../../Components/Commons/Forms/SelectField";
import ConfirmModal from "../../../Components/Modals/ConfirmModal";

// import { Image } from "antd";
// import { createFormAttachment } from "../../Helpers/API/CheckUpApi/FormApi";
import { Icd10Api } from "../../Helpers/API/PatientApi/PatientApi";
// import IcdComponent from "./IcdComponent";
import { useParams } from "react-router-dom";
import { Col, Row } from "react-bootstrap";
import { Checkbox, DatePicker, Radio, Select } from "antd";
import {
  createCheckUp,
  updateCheckUp,
  getAutoSuggestTherapeutics,
} from "../../Helpers/API/CheckUpApi/CheckUpApi";
import { toast } from "react-toastify";
import { validateCheckUp } from "../../Helpers/Utilities/Validations/CheckUp";
import dayjs from "dayjs";
import {
  formatLabel,
  getRole,
  getUser,
  refreshPage,
} from "../../Helpers/Utilities/Common";
import { DeleteOutlined } from "@ant-design/icons";
// import { refreshPage } from "../../Helpers/Utilities/Common";

const { Option } = Select;

function PhysicalExamination({
  showAdmit,
  showOutPatient,
  addCheckUpData,
  setAddCheckUpData,
  addCheckupDiagnosis,
  setAddCheckupDiagnosis,
  fetchAssessmentHistory,
  assessment,
  doctorOptions,
}) {
  const { id } = useParams();
  const role = getRole();
  const userId = getUser();
  const [showLoader, setShowLoader] = useState(false);
  // const [showSketchPad, setShowSketchPad] = useState(false);
  const [prompt, setPrompt] = useState(false);
  // const [sketchImage, setSketchImage] = useState(null);
  const [suggestDiagnosis, setSuggestDiagnosis] = useState([]);
  const [suggestComplaint, setSuggestComplaint] = useState([]);
  const [icd10Diagnosis, setIcd10Diagnosis] = useState([]);
  const [icd10DiagnosisList, setIcd10DiagnosisList] = useState({});
  const [checkup, setCheckup] = useState("");
  const [isError, setIsError] = useState({
    diagnosis: "",
  });

  const [medicalHistory, setMedicalHistory] = useState({
    allergies: { has: false, details: "" },
    hospitalizations: { has: false, details: "" },
    illnesses: { has: false, details: "" },
  });

  const [familyHistory, setFamilyHistory] = useState({
    hypertension: false,
    diabetes: false,
    asthma: false,
    cancer: false,
    cancerType: "",
    others: false,
    othersDetails: "",
  });

  const [personalHistory, setPersonalHistory] = useState({
    alcohol: { has: false, details: "" },
    smoking: { has: false, details: "" },
    drugs: { has: false, details: "" },
  });

  const [vitalSigns, setVitalSigns] = useState({
    bloodPressure: "",
    pulseRate: "",
    respiratoryRate: "",
    temperature: "",
    o2Sat: "",
    height: "",
    weight: "",
    bmi: "",
    lmp: "",
    visualAcuityLeft: "",
    visualAcuityRight: "",
    visualAcuityLeftCorrected: "",
    visualAcuityRightCorrected: "",
  });

  const [reviewSystems, setReviewSystems] = useState({
    general: { has: false, details: "" },
    vision: { has: false, details: "" },
    head_and_neck: { has: false, details: "" },
    ears: { has: false, details: "" },
    respiratory: { has: false, details: "" },
    cardiovascular: { has: false, details: "" },
    gastrointestinal: { has: false, details: "" },
    genitourinary: { has: false, details: "" },
    hematology: { has: false, details: "" },
    obgyn: { has: false, details: "" },
    neurological: { has: false, details: "" },
    musculoskeletal: { has: false, details: "" },
    skin: { has: false, details: "" },
  });

  const [physicalExam, setPhysicalExam] = useState({
    general: { status: "normal", notes: "" },
    skin: { status: "normal", notes: "" },
    head_and_neck: { status: "normal", notes: "" },
    eyes_ears_and_nose: { status: "normal", notes: "" },
    mouth_and_throat: { status: "normal", notes: "" },
    chest_and_lungs: { status: "normal", notes: "" },
    breast: { status: "normal", notes: "" },
    cardiovascular: { status: "normal", notes: "" },
    back: { status: "normal", notes: "" },
    abdomen: { status: "normal", notes: "" },
    extremities: { status: "normal", notes: "" },
    neurological: { status: "normal", notes: "" },
    rectal: { status: "normal", notes: "" },
    genitalia: { status: "normal", notes: "" },
  });

  // Handle patient information changes
  const handlePatientInfoChange = (field, value) => {
    setAddCheckUpData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle medical history changes
  const handleMedicalHistoryChange = (field, has, details = "") => {
    setMedicalHistory((prev) => ({
      ...prev,
      [field]: { has, details },
    }));
  };

  // Handle family history changes
  const handleFamilyHistoryChange = (field, value) => {
    setFamilyHistory((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle personal history changes
  const handlePersonalHistoryChange = (field, has, details = "") => {
    setPersonalHistory((prev) => ({
      ...prev,
      [field]: { has, details },
    }));
  };

  // Handle vital signs changes
  const handleVitalSignsChange = (field, value) => {
    setVitalSigns((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // Handle review of systems changes
  const handleReviewSystemsChange = (system, has, details = "") => {
    setReviewSystems((prev) => ({
      ...prev,
      [system]: { has, details },
    }));
  };

  // Handle physical exam changes
  const handlePhysicalExamChange = (system, field, value) => {
    setPhysicalExam((prev) => ({
      ...prev,
      [system]: {
        ...prev[system],
        [field]: value,
      },
    }));
  };

  //Function for handling the value of the input fields
  const handleAddChange = (e, search) => {
    if (search === "complaint") {
      setAddCheckUpData((prevState) => ({
        ...prevState,
        [search]: e?.value,
      }));
    } else if (
      search === "is_surgical_outpatient" ||
      search === "is_sunday_patient"
    ) {
      // Handle checkbox value (1 for checked, 0 for unchecked)
      setAddCheckUpData((prevState) => ({
        ...prevState,
        [search]: e.target.checked ? "1" : "0",
      }));
    } else {
      const { name, value } = e.target;
      if (name === "procedure") {
        setAddCheckUpData((prevState) => ({
          ...prevState,
          [name]: value?.toUpperCase(),
        }));
      } else {
        setAddCheckUpData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };

  const handleDiagnosisChange = (index, field, value) => {
    const updated = [...addCheckupDiagnosis];
    if (field === "sub_diagnosis") {
      const result = value.target.value;
      updated[index]["diagnosis_name"] = result;
      setAddCheckupDiagnosis(updated);
      setIcd10DiagnosisList({});
    } else {
      updated[index][field] = value;
      setAddCheckupDiagnosis(updated);
    }
  };

  const handleaddCheckupDiagnosis = () => {
    setAddCheckupDiagnosis((prev) => [...prev, { diagnosis_name: "" }]);
  };

  const handleRemoveDiagnosis = (index) => {
    setAddCheckupDiagnosis((prev) => prev.filter((_, i) => i !== index));
  };

  // Function for handling date for all diagnostics
  function handleDateChange(dateTime) {
    var formattedDateTime = dateTime ? dateTime.format("YYYY-MM-DD") : null;
    setAddCheckUpData((prev) => ({
      ...prev,
      last_checkup_date: formattedDateTime,
    }));
  }

  // Function for handling selected doctor
  function handleDoctorChange(value) {
    setAddCheckUpData((prev) => ({
      ...prev,
      doctor_id: value,
    }));
  }

  // const handleSetText = (data) => {
  //   setAddCheckUpData((prevState) => ({
  //     ...prevState,
  //     diagnosis: data,
  //   }));
  // };

  // const handleSetSketchImage = (image) => {
  //   setSketchImage(image)
  // };

  function handleCheckupType(type) {
    if (type === "for_admission") {
      addCheckUpIn();
    } else if (type === "outpatient") {
      addCheckUpOut();
    }
  }

  function handleCheckupButtons(name) {
    setPrompt(true);
    if (name === "outpatient") {
      setCheckup(name);
    } else if (name === "for_admission") {
      setCheckup(name);
    }
  }
  // async function handleUploadSketchImage(assessment_id) {
  //   // if (validateFileSize(sketchImage)) {
  //     const response = await createFormAttachment(id, [{file: sketchImage}], "diagnosis", "", "", assessment_id)
  //     if (response.error) {
  //       response.error?.data?.messages?.error_messages.map((data) => {
  //         return toast.error(data)
  //       })
  //     } else {
  //       toast.success("Successfully uploaded file!")
  //       // refreshPage();
  //     }
  //   // } else {
  //   //   toast.error("Invalid. File size exceeded 5MB.");
  //   // }
  // }

  async function fetchAutoSuggestTherapeutics() {
    setShowLoader(true);
    const response = await getAutoSuggestTherapeutics({
      table: "assessment_diagnosis",
      field: "diagnosis_name",
    });
    if (response.data) {
      setSuggestDiagnosis(
        response?.data?.data
          ?.filter((data) => data !== null && data !== undefined && data !== "")
          ?.map((data) => ({ label: data, value: data }))
      );
    } else {
      setSuggestDiagnosis([]);
    }
    setShowLoader(false);
  }

  async function fetchAutoSuggestComplaint() {
    setShowLoader(true);
    const response = await getAutoSuggestTherapeutics({
      table: "assessment",
      field: "complaint",
    });
    if (response.data) {
      setSuggestComplaint(
        response?.data?.data
          ?.filter((data) => data !== null && data !== undefined && data !== "")
          ?.map((data) => ({ label: data, value: data }))
      );
    } else {
      setSuggestComplaint([]);
    }
    setShowLoader(false);
  }

  async function Icd10(index, diagnosisName) {
    const response = await Icd10Api(diagnosisName);
    if (response?.data) {
      const _data =
        response.data[3]?.map((icd) => ({
          label: icd[0] + " - " + icd[1],
          value: icd[0] + " - " + icd[1],
        })) || [];

      setIcd10DiagnosisList((prev) => ({
        ...prev,
        [index]: [{ label: "Select ICD Diagnosis", value: "" }, ..._data],
      }));
    } else {
      setIcd10DiagnosisList((prev) => ({
        ...prev,
        [index]: [],
      }));
    }
  }
  // Function for creating admission API
  async function addCheckUpIn() {
    setShowLoader(true);
    if (role !== "nurse") {
      addCheckUpData.doctor_id = userId;
    }
    if (validateCheckUp(addCheckUpData, setIsError)) {
      const response = await createCheckUp(addCheckUpData, id, "for_admission");
      if (response.data) {
        toast.success(response.data.message);
        showAdmit(true);
        fetchAssessmentHistory();
        setTimeout(() => {
          refreshPage();
        }, 500);
        // handleUploadSketchImage(response.data.assessment_id);
      }
    }
    setPrompt(false);
    setShowLoader(false);
  }

  // const handleKeyPress = (event) => {
  //   // Check if the pressed key is Enter (key code 13)
  //   if (event.key === 'Enter') {
  //     // Trigger the button click event
  //     Icd10();
  //   }
  // };

  // Function for creating Outpatient API
  async function addCheckUpOut() {
    setShowLoader(true);
    if (role !== "nurse") {
      addCheckUpData.doctor_id = userId;
    }
    addCheckUpData.diagnosis = addCheckupDiagnosis;
    const response = await createCheckUp(addCheckUpData, id, "outpatient");
    if (response.data) {
      toast.success(response.data.message);
      showOutPatient(true);
      fetchAssessmentHistory();
      setTimeout(() => {
        refreshPage();
      }, 500);
      // handleUploadSketchImage(response.data.assessment_id);
    } else if (response.error) {
      response.error.data.messages.error_messages.forEach((errMsg) => {
        toast.error(errMsg);
      });
    }
    setPrompt(false);
    setShowLoader(false);
  }
  // Function edit checkup API
  async function editCheckUp() {
    setShowLoader(true);
    addCheckUpData.diagnosis = addCheckupDiagnosis;
    const response = await updateCheckUp(addCheckUpData, id);
    if (response.data) {
      toast.success(response.data.message);

      if (addCheckUpData.type === "outpatient") {
        showOutPatient(true);
      } else if (addCheckUpData.type === "for_admission") {
        showAdmit(true);
      }
      setTimeout(() => {
        refreshPage();
      }, 500);
    } else if (response.error) {
    }
    setShowLoader(false);
  }

  //   useEffect(() => {
  //     fetchAutoSuggestTherapeutics();
  //     fetchAutoSuggestComplaint();
  //     // eslint-disable-next-line react-hooks/exhaustive-deps
  //   }, []);

  // useEffect(() => {
  //   Icd10();
  // // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);
  return (
    <div className="tabs-box p-3">
      <div className="col pt-1">
        <div className="">
          <div className="row mt-2">
            <div className="col-sm-12">
              <label className="col-6 font-bold font-large ">
                Physical Examination
              </label>
              <hr />
              <div className="row">
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    PATIENT INFORMATION
                  </label>
                  <div className="row my-1">
                    <div className="col mb-2 ps-3">
                      <label>Company Name/HMO</label>
                      <TextField
                        value={addCheckUpData.company}
                        onChange={(e) =>
                          handlePatientInfoChange("company", e.target.value)
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-3 mb-2 mt-4">
                      <Checkbox
                        checked={addCheckUpData.ape}
                        onChange={(e) =>
                          handlePatientInfoChange("ape", e.target.checked)
                        }
                      >
                        APE
                      </Checkbox>
                      <Checkbox
                        checked={addCheckUpData.peme}
                        onChange={(e) =>
                          handlePatientInfoChange("peme", e.target.checked)
                        }
                      >
                        PEME
                      </Checkbox>
                    </div>
                    <div className="col-md-12 mb-2 ps-3">
                      <label>Patient Name</label>
                      <TextField
                        value={addCheckUpData.patientName}
                        onChange={(e) =>
                          handlePatientInfoChange("patientName", e.target.value)
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-4 mb-2 ps-3">
                      <label>Date of Birth</label>
                      <DatePicker
                        value={
                          addCheckUpData.dob ? dayjs(addCheckUpData.dob) : null
                        }
                        onChange={(date) =>
                          handlePatientInfoChange(
                            "dob",
                            date ? date.format("YYYY-MM-DD") : ""
                          )
                        }
                        className="w-100"
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-2 mb-2">
                      <label>Gender</label>
                      <div>
                        <Checkbox
                          checked={addCheckUpData.gender === "M"}
                          onChange={() =>
                            handlePatientInfoChange("gender", "M")
                          }
                          disabled={true}
                        >
                          Male
                        </Checkbox>
                        <Checkbox
                          checked={addCheckUpData.gender === "F"}
                          onChange={() =>
                            handlePatientInfoChange("gender", "F")
                          }
                          className="ml-2"
                          disabled={true}
                        >
                          Female
                        </Checkbox>
                      </div>
                    </div>
                    <div className="col-md-2 mb-2">
                      <label>Status</label>
                      <TextField
                        value={addCheckUpData.status}
                        onChange={(e) =>
                          handlePatientInfoChange("status", e.target.value)
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-2 mb-2">
                      <label>Religion</label>
                      <TextField
                        value={addCheckUpData.religion}
                        onChange={(e) =>
                          handlePatientInfoChange("religion", e.target.value)
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-2 mb-2">
                      <label>Nationality</label>
                      <TextField
                        value={addCheckUpData.nationality}
                        onChange={(e) =>
                          handlePatientInfoChange("nationality", e.target.value)
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-8 mb-2 ps-3">
                      <label>Current Address</label>
                      <TextField
                        value={addCheckUpData.address}
                        onChange={(e) =>
                          handlePatientInfoChange("address", e.target.value)
                        }
                        disabled={true}
                      />
                    </div>
                    <div className="col-md-4 mb-2">
                      <label>Occupation</label>
                      <TextField
                        value={addCheckUpData.occupation}
                        onChange={(e) =>
                          handlePatientInfoChange("occupation", e.target.value)
                        }
                        disabled={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    PAST MEDICAL HISTORY
                  </label>
                  {["allergies", "hospitalizations", "illnesses"].map(
                    (item) => (
                      <div key={item} className="row mb-2">
                        <div className="col ms-2">
                          <label className="font-bold my-1 text-capitalize">
                            {item}
                          </label>
                          <div className="d-flex align-items-center mt-1">
                            {/* <Radio.Group
                              value={medicalHistory[item].has ? "yes" : "no"}
                              onChange={(e) =>
                                handleMedicalHistoryChange(
                                  item,
                                  e.target.value === "yes"
                                )
                              }
                              className="ml-2"
                            >
                              <Radio value="no">NO</Radio>
                              <Radio value="yes" className="ml-3">
                                YES, Please elaborate.
                              </Radio>
                            </Radio.Group> */}
                            <Checkbox
                              checked={!medicalHistory[item].has}
                              onChange={() =>
                                handleMedicalHistoryChange(item, false)
                              }
                            >
                              NO
                            </Checkbox>
                            <Checkbox
                              checked={medicalHistory[item].has}
                              onChange={() =>
                                handleMedicalHistoryChange(item, true)
                              }
                              className="ml-3"
                            >
                              YES, Please elaborate.
                            </Checkbox>
                          </div>
                          {medicalHistory[item].has && (
                            <div className="mt-3 ms-1">
                              <TextArea
                                smallPlaceholder
                                value={medicalHistory[item].details}
                                onChange={(e) =>
                                  handleMedicalHistoryChange(
                                    item,
                                    true,
                                    e.target.value
                                  )
                                }
                                rows={1}
                                placeholder={`Please provide details about ${item}.`}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    )
                  )}
                </div>
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    FAMILY HISTORY/HEREDOFAMILIAL DISEASES <br />
                    (Please check if applicable.)
                  </label>
                  <div className="row mt-2">
                    <div className="col-12 my-1">
                      <Checkbox
                        checked={familyHistory.hypertension}
                        onChange={(e) =>
                          handleFamilyHistoryChange(
                            "hypertension",
                            e.target.checked
                          )
                        }
                      >
                        HYPERTENSION
                      </Checkbox>
                    </div>
                    <div className="col-12 my-1">
                      <Checkbox
                        checked={familyHistory.asthma}
                        onChange={(e) =>
                          handleFamilyHistoryChange("asthma", e.target.checked)
                        }
                      >
                        ASTHMA
                      </Checkbox>
                    </div>
                    <div className="col-12 my-1">
                      <Checkbox
                        checked={familyHistory.diabetes}
                        onChange={(e) =>
                          handleFamilyHistoryChange(
                            "diabetes",
                            e.target.checked
                          )
                        }
                      >
                        DIABETES
                      </Checkbox>
                    </div>
                    <div className="col-12 my-1">
                      <Checkbox
                        checked={familyHistory.cancer}
                        onChange={(e) =>
                          handleFamilyHistoryChange("cancer", e.target.checked)
                        }
                      >
                        CANCER, please specify.
                      </Checkbox>
                      {familyHistory.cancer && (
                        <TextArea
                          smallPlaceholder
                          value={familyHistory.cancerType}
                          onChange={(e) =>
                            handleFamilyHistoryChange(
                              "cancerType",
                              e.target.value
                            )
                          }
                          rows={1}
                          placeholder={`Please provide details.`}
                        />
                      )}
                    </div>
                    <div className="col-12 my-1">
                      <Checkbox
                        checked={familyHistory.others}
                        onChange={(e) =>
                          handleFamilyHistoryChange("others", e.target.checked)
                        }
                      >
                        OTHERS, please specify.
                      </Checkbox>
                      {familyHistory.others && (
                        <TextArea
                          smallPlaceholder
                          value={familyHistory.othersDetails}
                          onChange={(e) =>
                            handleFamilyHistoryChange(
                              "othersDetails",
                              e.target.value
                            )
                          }
                          rows={1}
                          placeholder={`Please provide details.`}
                        />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    PERSONAL - SOCIAL HISTORY
                  </label>
                  {["alcohol", "smoking", "drugs"].map((item) => (
                    <div key={item} className="row mb-2">
                      <div className="col ms-2">
                        <label className="font-bold my-1 text-capitalize">
                          {item}
                        </label>
                        <div className="d-flex align-items-center mt-1">
                          <Checkbox
                            checked={!personalHistory[item].has}
                            onChange={() =>
                              handlePersonalHistoryChange(item, false)
                            }
                          >
                            NO
                          </Checkbox>
                          <Checkbox
                            checked={personalHistory[item].has}
                            onChange={() =>
                              handlePersonalHistoryChange(item, true)
                            }
                            className="ml-3"
                          >
                            YES, Please elaborate.
                          </Checkbox>
                        </div>
                        {personalHistory[item].has && (
                          <div className="mt-3 ms-1">
                            <TextArea
                              smallPlaceholder
                              value={personalHistory[item].details}
                              onChange={(e) =>
                                handlePersonalHistoryChange(
                                  item,
                                  true,
                                  e.target.value
                                )
                              }
                              rows={1}
                              placeholder={`Please provide details.`}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    NURSING ASSESSMENT - VITAL SIGNS
                  </label>
                  <div className="row">
                    <div className="col ms-2">
                      <div className="row mb-2 my-1">
                        <div className="col">
                          <label>Blood Pressure</label>
                          <TextField
                            value={vitalSigns.bloodPressure}
                            onChange={(e) =>
                              handleVitalSignsChange(
                                "bloodPressure",
                                e.target.value
                              )
                            }
                            suffix="mmHg"
                          />
                        </div>
                        <div className="col">
                          <label>Height</label>
                          <TextField
                            value={vitalSigns.height}
                            onChange={(e) =>
                              handleVitalSignsChange("height", e.target.value)
                            }
                            suffix="cm"
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col">
                          <label>Pulse Rate</label>
                          <TextField
                            value={vitalSigns.pulseRate}
                            onChange={(e) =>
                              handleVitalSignsChange(
                                "pulseRate",
                                e.target.value
                              )
                            }
                            suffix="bpm"
                          />
                        </div>
                        <div className="col">
                          <label>Weight</label>
                          <TextField
                            value={vitalSigns.weight}
                            onChange={(e) =>
                              handleVitalSignsChange("weight", e.target.value)
                            }
                            suffix="kg"
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col">
                          <label>Respiratory Rate</label>
                          <TextField
                            value={vitalSigns.respiratoryRate}
                            onChange={(e) =>
                              handleVitalSignsChange(
                                "respiratoryRate",
                                e.target.value
                              )
                            }
                            suffix="cpm"
                          />
                        </div>
                        <div className="col">
                          <label>BMI</label>
                          <TextField value={vitalSigns.bmi} readOnly />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col">
                          <label>Temperature</label>
                          <TextField
                            value={vitalSigns.temperature}
                            onChange={(e) =>
                              handleVitalSignsChange(
                                "temperature",
                                e.target.value
                              )
                            }
                            suffix="°C"
                          />
                        </div>
                        <div className="col">
                          <label>O2 Sat</label>
                          <TextField
                            value={vitalSigns.o2Sat}
                            onChange={(e) =>
                              handleVitalSignsChange("o2Sat", e.target.value)
                            }
                          />
                        </div>
                      </div>
                      <div className="row mb-2">
                        <div className="col-6">
                          <label>LMP (for females only)</label>
                          <DatePicker
                            value={
                              vitalSigns.lmp ? dayjs(vitalSigns.lmp) : null
                            }
                            onChange={(date) =>
                              handleVitalSignsChange(
                                "lmp",
                                date ? date.format("YYYY-MM-DD") : ""
                              )
                            }
                            className="w-100"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    VISUAL ACUITY
                  </label>
                  <div className="row">
                    <div className="row mb-2 my-1">
                      <div className="col ms-2">
                        <label>Without correction - Left eye</label>
                        <TextField
                          value={vitalSigns.visualAcuityLeft}
                          onChange={(e) =>
                            handleVitalSignsChange(
                              "visualAcuityLeft",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col ms-2">
                        <label>Without correction - Right eye</label>
                        <TextField
                          value={vitalSigns.visualAcuityRight}
                          onChange={(e) =>
                            handleVitalSignsChange(
                              "visualAcuityRight",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>
                    <div className="row mb-2">
                      <div className="col ms-2">
                        <label>With glasses/contact lenses - Left eye</label>
                        <TextField
                          value={vitalSigns.visualAcuityLeftCorrected}
                          onChange={(e) =>
                            handleVitalSignsChange(
                              "visualAcuityLeftCorrected",
                              e.target.value
                            )
                          }
                        />
                      </div>
                      <div className="col ms-2">
                        <label>With glasses/contact lenses - Right eye</label>
                        <TextField
                          value={vitalSigns.visualAcuityRightCorrected}
                          onChange={(e) =>
                            handleVitalSignsChange(
                              "visualAcuityRightCorrected",
                              e.target.value
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    REVIEW OF SYSTEMS
                  </label>
                  <div className="row">
                    {Object.keys(reviewSystems).map((system) => (
                      <div key={system} className="col-6 mb-2 ps-3">
                        <label className="font-bold my-1 text-capitalize">
                          {formatLabel(system)}
                        </label>
                        <div className="d-flex align-items-center mb-1">
                          <Checkbox
                            checked={!reviewSystems[system].has}
                            onChange={() =>
                              handleReviewSystemsChange(system, false)
                            }
                          >
                            NO
                          </Checkbox>
                          <Checkbox
                            checked={reviewSystems[system].has}
                            onChange={() =>
                              handleReviewSystemsChange(system, true)
                            }
                            className="ml-3"
                          >
                            YES, please specify.
                          </Checkbox>
                        </div>
                        {reviewSystems[system].has && (
                          <TextArea
                            smallPlaceholder
                            value={reviewSystems[system].details}
                            onChange={(e) =>
                              handleReviewSystemsChange(
                                system,
                                true,
                                e.target.value
                              )
                            }
                            rows={1}
                            className="mt-1"
                            placeholder={`Please provide details.`}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="col ms-3">
                  <label className="col font-bold font-medium ">
                    PHYSICAL EXAMINATION
                  </label>
                  <div className="row">
                    {Object.keys(physicalExam).map((system) => (
                      <div key={system} className="col-md-6 mb-2 ps-3">
                        <label className="font-bold my-1 text-capitalize">
                          {system === "eyes_ears_and_nose"
                            ? "Eyes, Ears, And Nose"
                            : formatLabel(system)}
                        </label>
                        <div className="d-flex align-items-center mb-1">
                          <Checkbox
                            checked={physicalExam[system].status === "normal"}
                            onChange={() =>
                              handlePhysicalExamChange(
                                system,
                                "status",
                                "normal"
                              )
                            }
                          >
                            NORMAL
                          </Checkbox>
                          <Checkbox
                            checked={physicalExam[system].status === "abnormal"}
                            onChange={() =>
                              handlePhysicalExamChange(
                                system,
                                "status",
                                "abnormal"
                              )
                            }
                            className="ml-2"
                          >
                            ABNORMAL
                          </Checkbox>
                          <Checkbox
                            checked={physicalExam[system].status === "not_done"}
                            onChange={() =>
                              handlePhysicalExamChange(
                                system,
                                "status",
                                "not_done"
                              )
                            }
                            className="ml-2"
                          >
                            NOT DONE
                          </Checkbox>
                        </div>
                        {physicalExam[system].status === "abnormal" && (
                          <TextArea
                            smallPlaceholder
                            value={physicalExam[system].notes}
                            onChange={(e) =>
                              handlePhysicalExamChange(
                                system,
                                "notes",
                                e.target.value
                              )
                            }
                            rows={1}
                            className="mt-1"
                            placeholder="Please specify abnormal findings."
                          />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Row className="justify-content-end mt-5 mb-3">
            {addCheckUpData.id ? (
              <>
                <Col xs={2} className="col-container">
                  <BtnSave
                    label={"Save Changes"}
                    size={"sm"}
                    onClick={editCheckUp}
                    isClicked={showLoader}
                    disabled={
                      !addCheckUpData ||
                      !addCheckUpData.doctor_id ||
                      !addCheckUpData.complaint ||
                      !addCheckUpData.subjective ||
                      !addCheckUpData.objective ||
                      !addCheckupDiagnosis ||
                      addCheckupDiagnosis.length === 0 ||
                      addCheckupDiagnosis.some(
                        (item) =>
                          !item?.diagnosis_name ||
                          item?.diagnosis_name.trim() === ""
                      )
                    }
                  />
                </Col>
              </>
            ) : (
              <>
                <Col xs={2} className="col-container">
                  <BtnAdd
                    label={"Proceed"}
                    size={"sm"}
                    onClick={() => handleCheckupButtons("outpatient")}
                    isClicked={showLoader}
                    disabled={
                      !addCheckUpData ||
                      (role === "nurse" && !addCheckUpData.doctor_id) ||
                      !addCheckUpData.complaint ||
                      !addCheckUpData.subjective ||
                      !addCheckUpData.objective ||
                      !addCheckupDiagnosis ||
                      addCheckupDiagnosis.length === 0 ||
                      addCheckupDiagnosis.some(
                        (item) =>
                          !item?.diagnosis_name ||
                          item?.diagnosis_name.trim() === ""
                      )
                    }
                  />
                </Col>
              </>
            )}
          </Row>
        </div>
      </div>
      <ConfirmModal
        show={prompt}
        onHide={() => setPrompt(false)}
        onConfirm={() => handleCheckupType(checkup)}
        message={
          <>
            <p>
              Are you sure this is the right diagnosis for this patient (
              {checkup ? checkup : ""})?
            </p>
            {addCheckupDiagnosis?.length > 0 && (
              <div style={{ textAlign: "left" }}>
                <ul className="mx-3">
                  {addCheckupDiagnosis.map((d, index) => (
                    <li key={index}>{d.diagnosis_name}</li>
                  ))}
                </ul>
              </div>
            )}
          </>
        }
      />
    </div>
  );
}

export default PhysicalExamination;
